import {instance} from "../../config/axios-cnf";

export const apiGetCron = (callback, error) => {
    instance.get("/api/v2/cron")
        .then(response => callback(response.data))
        .catch(err => error(err))
}
